import React from 'react';
import { Helmet } from 'react-helmet';
import SingleBlogPost from './BlogPostSingle';

const SingleBlogPostPage = () => (
  <>
    <Helmet>
      <title>Blog Post | MilaajBrandset</title>
      <meta
        name="description"
        content="Read the latest insights and updates from MilaajBrandset's blog. Explore detailed articles and expert opinions on various topics."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, blog post, insights, updates, expert opinions"
      />
      <meta property="og:title" content="Blog Post | MilaajBrandset" />
      <meta
        property="og:description"
        content="Read the latest insights and updates from MilaajBrandset's blog. Explore detailed articles and expert opinions on various topics."
      />
    </Helmet>
    <SingleBlogPost />
  </>
);

export default SingleBlogPostPage;